import FileSaver from 'file-saver';

const saveFile = (file, fileName) => FileSaver.saveAs(file, fileName);

export default saveFile;
